import {
    isArray,
    filter,
    fixNumber,
    prop,
    map,
    inArray,
    findIndex,
    forIn,
    find,
    assign
} from "../../../../common/utils";
import {
    KUser
} from "../../../../models/user";

// 擂台信息
function _getCup(state, cupId) {
    return prop(state.cupsMap, cupId, null)
}
// 擂台信息
function _getGame(state, gameId) {
    return prop(state.gamesMap, gameId, null)
}
// 擂台信息
function _getPlayInfo(key, defaultValue) {
    return state => prop(state.playInfo, key, defaultValue)
}

// function getPlayGameId(state) {
//     return prop(state.playInfo, 'gameId', 0)
// }

// function getPlayKid(state) {
//     return prop(state.playInfo, 'kid', 0)
// }
// function getPlayCupId(state) {
//     return prop(state.playInfo, 'cupId', 0)
// }

// 已完成 kids
function _getActionList(state, gameId) {
    return prop(_getGame(state, gameId), 'actionList', [])
}

function allActions(state) {
    let actions = []
    forIn(state.gamesMap, (g) => {
        actions = actions.concat(prop(g, 'actionList', []))
    })
    return actions
}

// 已完成 playActions
function playActions(state) {
    return _getActionList(state, curGameId(state))
}
// 当前题目的action
function curAction(state) {
    const kid = curKid(state)
    return kid > 0 ? find(playActions(state), action => action.kid === kid) : null
}
// 当前题号
function curOid(state) {
    const kid = curKid(state)

    return kid > 0 ? findIndex(allKids(state), id => id === kid) + 1 : 0
}

const playKlines = _getPlayInfo('klines', [])
const curCupId = _getPlayInfo('cupId', 0)
const curGameId = _getPlayInfo('gameId', 0)
const curKid = _getPlayInfo('kid', 0)
const curGameUid = _getPlayInfo('uid', 0)

// 所有 kids
function allKids(state) {
    const kids = prop(state._cupPlayer, 'kids', [])
    return isArray(kids) ? kids : []
}

// 下一题
function _nextKidOf(state, kid) {
    const kids = allKids(state)
    const i = kid > 0 ? findIndex(kids, n => n === kid) : -1
    return kids.length ? kids[i + 1] : 0
}

function nextKidOf(state) {
    return kid => _nextKidOf(state, kid)
}

// 上一题
function _prevKidOf(state, kid) {
    const kids = allKids(state)
    // console.log(kids);
    const i = kid > 0 ? findIndex(kids, n => n === kid) : 0
    // console.log([i, kids[i + 1]]);
    return kids.length ? kids[i - 1] : 0
}

function prevKidOf(state) {
    return kid => _prevKidOf(state, kid)
}

// 已完成 kids
function playedKids(state) {
    return map(playActions(state), o => o.kid)
}

// 下一根训练 kid
function nextPlayKid(state) {
    return _nextKidOf(state, curKid(state))
    // const kids = playedKids(state)
    // const kid = getPlayKid(state)
    // const i = kid > 0 ? findIndex(kids, n => n === kid) : 0
    // return kids.length ? kids[i] : 0
}

function prevPlayKid(state) {
    return _prevKidOf(state, curKid(state))
    // const kids = playedKids(state)
    // const kid = getPlayKid(state)
    // const i = kid > 0 ? findIndex(kids, n => n === kid) : 0
    // return kids.length ? kids[i] : 0
}

// 待完成 kids
function waitPlayKids(state) {
    const played = playedKids(state)
    const all = allKids(state)
    return filter(all, kid => !inArray(played, kid))
}

// 下一根待做的 kid
function nextWaitKid(state) {
    const kids = waitPlayKids(state)
    // console.log(kids)
    return kids.length ? kids[0] : 0
}

// 是否为合法的 kid
function isValidKid(state) {
    return (kid) => kid > 0 && inArray(allKids(state), kid)
}

function isPlayedKid(state) {
    return (kid) => kid > 0 && inArray(playedKids(state), kid)
}


function _getKlineAt(index, state) {
    const klines = playKlines(state)
    if (klines) {
        const {
            length
        } = klines
        index = index < 1 ? length + index : index >= 0 ? +index : length - 1
        return index < length ? klines[index] : null
    }
    return null
}

function getKlineAt(state) {
    return (index) => _getKlineAt(index, state)
}

function lastKline(state) {
    return _getKlineAt(-1, state)
}


function getActionBy(state) {
    return (kid) => find(playActions(state), action => action.kid === kid)
}

// 预测范围： 跌停 ~ 涨停
function predictRange(state) {
    const Kline = lastKline(state)
    if (Kline) {
        let close = Kline.close
        if (close > 0) {
            close = Math.round(100 * close) // 取整：元转成分
            const minPrice = Math.round(close * 0.9)
            const maxPrice = Math.round(close * 1.1)
            const minRate = fixNumber((minPrice - close) / close, 4) // 跌停, 精确到4位小数
            const maxRate = fixNumber((maxPrice - close) / close, 4) // 涨停, 精确到4位小数
            return {
                minPrice: fixNumber(minPrice / 100, 2),
                maxPrice: fixNumber(maxPrice / 100, 2),
                minRate, // 精确到4位小数
                maxRate
            }
        }
    }
    return null
}

// function waitPlayKids(state) {
//     const {gameInfo} = state
//     const played = playedKids(state)
//     if(gameInfo) {
//         const {playedKids} = gameInfo
//         return playedKids ? playedKids : []
//     }
//     return []
// }

function playedCount(state) {
    return playedKids(state).length
}

function allCount(state) {
    return allKids(state).length
}

function waitCount(state) {
    return waitPlayKids(state).length
}

function _getUseInfo(state, uid) {
    return prop(state.userMap, uid, KUser({
        uid: uid,
        nick: `wz_${uid}`
    }))
}

export default {
    allKids,
    allCount,
    playedCount,
    playedKids,
    waitPlayKids,
    waitCount,
    nextWaitKid,
    isValidKid,
    isPlayedKid,
    getKlineAt,
    getActionBy,
    lastKline,
    predictRange,
    cupPlayer(state) {
        return state._cupPlayer
    },
    getCup(state) {
        return cupId => _getCup(state, cupId)
    },
    getCupName(state) {
        return cupId => prop(_getCup(state, cupId), 'cupName', '')
    },
    getGame(state) {
        return gameId => _getGame(state, gameId)
    },
    getActionList(state) {
        return (gameId) => _getActionList(state, gameId)
    },
    isFinished(state) {
        const played = playedCount(state)
        return played > 0 && played >= allCount(state)
    },
    uid: (state) => prop(state.gameInfo, 'uid', 0),
    gameId: (state) => prop(state.gameInfo, 'gameId', 0),

    getUserInfo: (state) => (uid) => _getUseInfo(state, uid),
    rankList(state) {
        return map(state._rankList, d => {
            const user = _getUseInfo(state, d.uid) || {}
            const {uid, nick, logoSrc} = user
            return assign({uid, nick, logoSrc}, d)
        })
    },

    // 当前训练页的gameId
    curGameId,
    curCupId,
    curGameUid,
    curOid,
    curKid,
    curAction,

    prevKidOf,
    nextKidOf,
    nextPlayKid, // 下一题
    prevPlayKid, // 上一题
    playKlines,
    playActions,
    allActions
}
